import { defineMessages } from 'react-intl.macro';
import { Collapsible } from '@tmapy/style-guide';
import { useDispatch } from '@tmapy/redux';

import './ManagerMenu.scss';

import React, { useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { useMessage } from '@tmapy/intl';

import { CHECK_FLOWS, FLOW_CROSS } from '../docs/constants';

import { FilterLink } from '../FilterLink';
import { useAuth, useSelector } from '../hooks';
import { setMenuRouteIsCollapsed } from '../redux/menu/actions';
import { Menu } from '../app/components/Menu';

const msg = defineMessages({
  title: {
    id: 'manager.title',
    defaultMessage: 'Manažer',
  },
  subtitle: {
    id: 'manager.subtitle',
    defaultMessage: ' ',
  },
  checks: {
    id: 'manager.menu.prejimky',
    defaultMessage: 'Kontroly aktualizačních dat',
  },
  checksAll: {
    id: 'manager.menu.checksAll',
    defaultMessage: 'Všechny kontroly',
  },
  checksChecking: {
    id: 'manager.menu.checksChecking',
    defaultMessage: 'Probíhající',
  },
  checksPassed: {
    id: 'manager.menu.checksPassed',
    defaultMessage: 'Dokončeno v pořádku',
  },
  checksFailed: {
    id: 'manager.menu.checksFailed',
    defaultMessage: 'Dokončeno s chybou',
  },
  checksAborted: {
    id: 'manager.menu.checksAborted',
    defaultMessage: 'Neproběhlé',
  },

  docs: {
    id: 'manager.menu.docs',
    defaultMessage: 'Příjem aktualizačních dat',
  },
  docsList: {
    id: 'manager.menu.docsList',
    defaultMessage: 'Přehled dokumentací',
  },
  docsAll: {
    id: 'manager.menu.docsAll',
    defaultMessage: 'Všechny dokumentace',
  },
  dmvsDti: {
    id: 'manager.menu.dmvsDti',
    defaultMessage: 'DMVS DTI',
  },
  dmvsDtiOngoing: {
    id: 'manager.menu.dmvsDtiOngoing',
    defaultMessage: 'Probíhající',
  },
  dmvsDtiClosed: {
    id: 'manager.menu.dmvsDtiClosed',
    defaultMessage: 'Uzavřená',
  },
  dmvsDtiRejected: {
    id: 'manager.menu.dmvsDtiRejected',
    defaultMessage: 'Odmítnutá',
  },
  dmvsDtiFailed: {
    id: 'manager.menu.dmvsDtiFailed',
    defaultMessage: 'Chyby',
  },
  dmvsGad: {
    id: 'manager.menu.dmvsGad',
    defaultMessage: 'DMVS GAD',
  },
  dmvsGadSubmitted: {
    id: 'manager.menu.dmvsGadSubmitted',
    defaultMessage: 'Nová',
  },
  dmvsGadOngoing: {
    id: 'manager.menu.dmvsGadOngoing',
    defaultMessage: 'Probíhající',
  },
  dmvsGadClosed: {
    id: 'manager.menu.dmvsGadClosed',
    defaultMessage: 'Uzavřená',
  },
  dmvsGadEditing: {
    id: 'manager.menu.dmvsGadEditing',
    defaultMessage: 'K editaci',
  },
  dmvsGadTakenOver: {
    id: 'manager.menu.dmvsGadTakenOver',
    defaultMessage: 'Převzatá krajem',
  },
  dmvsGadRejected: {
    id: 'manager.menu.dmvsGadRejected',
    defaultMessage: 'Odmítnutá',
  },
  dmvsGadFailed: {
    id: 'manager.menu.dmvsGadFailed',
    defaultMessage: 'Chyby',
  },
  dtmkDti: {
    id: 'manager.menu.dtmkDti',
    defaultMessage: 'DTMK DTI',
  },
  dmvsCross: {
    id: 'manager.menu.dmvsCross',
    defaultMessage: 'Přeshraniční editace',
  },
  dmvsCrossNew: {
    id: 'manager.menu.dmvsCrossNew',
    defaultMessage: 'Nová',
  },
  dmvsCrossProcessing: {
    id: 'manager.menu.dmvsCrossProcessing',
    defaultMessage: 'Probíhající',
  },
  dmvsCrossWaiting: {
    id: 'manager.menu.dmvsCrossWaiting',
    defaultMessage: 'Čeká na druhou stranu',
  },
  dmvsCrossClosed: {
    id: 'manager.menu.dmvsCrossClosed',
    defaultMessage: 'Uzavřená',
  },
  dmvsCrossRejected: {
    id: 'manager.menu.dmvsCrossRejected',
    defaultMessage: 'Odmítnutá',
  },
  dmvsCrossFailed: {
    id: 'manager.menu.dmvsCrossFailed',
    defaultMessage: 'Chyby',
  },
  subjects: {
    id: 'manager.menu.subjects',
    defaultMessage: 'Subjekty',
  },
  podaniKadList: {
    id: 'manager.menu.podaniKadList',
    defaultMessage: 'DTMK KAD',
  },
  podaniKad: {
    id: 'manager.menu.podaniKad',
    defaultMessage: 'Podání KAD',
  },
  geodesists: {
    id: 'manager.menu.geodesists',
    defaultMessage: 'Geodeti',
  },
  svu: {
    id: 'manager.menu.svu',
    defaultMessage: 'SVÚ oblasti',
  },
  dmvsCrossSvu: {
    id: 'manager.menu.dmvsCrossSvu',
    defaultMessage: 'SVÚ',
  },
  epsi: {
    id: 'manager.menu.epsi',
    defaultMessage: 'Aktualizace EPSI',
  },
  epsiSection: {
    id: 'manager.menu.epsiSection',
    defaultMessage: 'EPSI',
  },
});

export const CustomMenu: React.FC = () => {
  const { customerType } = useSelector((state) => state.app.config);

  const newFormIdent = useMemo(() => {
    switch (customerType) {
      case 'cepro':
        return 'ceproDocNew';
      case 'bb':
        return 'bbDocNew';
      default:
        return null;
    }
  }, [customerType]);

  return (
    <ul className='sg-u-vs-4'>
      <li>
        <p className='sg-u-type-sideNavHeading-inverse'>
          <FormattedMessage {...msg.docs} />
        </p>
        <ul className='sg-a-mt-1 sg-u-vs-1'>
          <li>
            <FilterLink id='managerDocList' to='managerDocList' />
          </li>
          {newFormIdent && (
            <li>
              <FilterLink id={newFormIdent} to={newFormIdent} />
            </li>
          )}
        </ul>
      </li>
    </ul>
  );
};

export const DtmMenu: React.FC = () => {
  const auth = useAuth();
  const dispatch = useDispatch();
  const formatMessage = useMessage();
  const { manager } = useSelector((state) => state.app.config);
  const collapsible = useSelector((state) => state.menu.collapsible);

  const onCollapseClick = useCallback(
    (e: React.MouseEvent, eventData: { data: string }) => {
      dispatch(
        setMenuRouteIsCollapsed({
          id: eventData.data,
          isCollapsible: !collapsible[eventData.data],
        }),
      );
    },
    [collapsible, dispatch],
  );

  return (
    <>
      <ul className='sg-u-vs-4'>
        {(auth.hasPermission('RelatedApps', 'allow_manager_all', null) ||
          auth.hasPermission('RelatedApps', 'allow_manager_dtm_dti', null)) && (
            <li>
              <p className='sg-u-type-sideNavHeading-inverse'>
                <FormattedMessage {...msg.checks} />
              </p>
              <ul className='sg-a-mt-1 sg-u-vs-1'>
                <li>
                  <FilterLink id='managerNewCheck' to='managerNewCheck' />
                </li>
                {/* CHECKS */}
                <Collapsible
                  isClosed={!!collapsible.managerCheckList}
                  data={'managerCheckList'}
                  onClick={onCollapseClick}
                  headElement={
                    <FilterLink
                      id='managerCheckList'
                      to='managerCheckList'
                      label={formatMessage(msg.checksAll)}
                      filter={{}}
                    />
                  }
                >
                  <li>
                    <ul className='sg-a-mt-1 sg-u-vs-1 dmx-menu-group'>
                      <li>
                        <FilterLink
                          id='managerCheckChecking'
                          to='managerCheckList'
                          label={formatMessage(msg.checksChecking)}
                          filter={{
                            latest_check_state__in: ['CHECKING', 'WAITING_FOR_CHECKING'],
                          }}
                        />
                      </li>
                      <li>
                        <FilterLink
                          id='managerCheckPassed'
                          to='managerCheckList'
                          label={formatMessage(msg.checksPassed)}
                          filter={{
                            latest_check_state__in: ['PASSED'],
                          }}
                        />
                      </li>
                      <li>
                        <FilterLink
                          id='managerCheckFailed'
                          to='managerCheckList'
                          label={formatMessage(msg.checksFailed)}
                          filter={{
                            latest_check_state__in: ['FAILED'],
                          }}
                        />
                      </li>
                      <li>
                        <FilterLink
                          id='managerCheckAborted'
                          to='managerCheckList'
                          label={formatMessage(msg.checksAborted)}
                          filter={{
                            latest_check_state__in: ['ABORTED'],
                          }}
                        />
                      </li>
                    </ul>
                  </li>
                </Collapsible>
              </ul>
            </li>
          )}
        {(auth.hasPermission('RelatedApps', 'allow_manager_all', null) ||
          auth.hasPermission('RelatedApps', 'allow_manager_dtm_dti', null)) && (
            <li>
              <p className='sg-u-type-sideNavHeading-inverse'>
                <FormattedMessage {...msg.docs} />
              </p>
              <ul className='sg-a-mt-1 sg-u-vs-1'>
                {(auth.hasPermission('RelatedApps', 'allow_manager_all', null) ||
                  auth.hasPermission('RelatedApps', 'allow_manager_dtm_dti', null)) && (
                    <li>
                      <FilterLink id='podaniDTINew' to='podaniDTINew' />
                    </li>
                  )}
                {manager?.modules?.podaniKad &&
                  auth.hasPermission('RelatedApps', 'allow_manager_all', null) && (
                    <li>
                      <FilterLink id='podaniKADNew' to='podaniKADNew' />
                    </li>
                  )}
              </ul>
            </li>
          )}
        <li>
          <p className='sg-u-type-sideNavHeading-inverse'>
            <FormattedMessage {...msg.docsList} />
          </p>
          <ul className='sg-a-mt-1 sg-u-vs-1'>
            {/* ALL */}
            {auth.hasPermission('RelatedApps', 'allow_manager_all', null) && (
              <li>
                <div className='sg-a-ml-0'>
                  <FilterLink
                    id='managerDocListAll'
                    to='managerDocList'
                    label={formatMessage(msg.docsAll)}
                    filter={{
                      flow__not_in: CHECK_FLOWS
                    }}
                  />
                </div>
              </li>
            )}
            {/* DMVS GAD */}
            {auth.hasPermission('RelatedApps', 'allow_manager_all', null) && (
              <Collapsible
                isClosed={!!collapsible.managerDocListDmvsGad}
                data={'managerDocListDmvsGad'}
                onClick={onCollapseClick}
                headElement={
                  <FilterLink
                    id='managerDocListDmvsGad'
                    to='managerDocList'
                    label={formatMessage(msg.dmvsGad)}
                    filter={{
                      prejimka_type__in: ['DMVS_GAD'],
                      flow__in: ['DMVS_GAD'],
                    }}
                  />
                }
              >
                <li>
                  <ul className='sg-a-mt-1 sg-u-vs-1 dmx-menu-group'>
                    <li>
                      <FilterLink
                        id='managerDocListDmvsGadSubmitted'
                        to='managerDocList'
                        label={formatMessage(msg.dmvsGadSubmitted)}
                        filter={{
                          prejimka_type__in: ['DMVS_GAD'],
                          flow__in: ['DMVS_GAD'],
                          state__in: ['SUBMITTED'],
                        }}
                      />
                    </li>
                    <li>
                      <FilterLink
                        id='managerDocListDmvsGadOngoing'
                        to='managerDocList'
                        label={formatMessage(msg.dmvsGadOngoing)}
                        filter={{
                          prejimka_type__in: ['DMVS_GAD'],
                          flow__in: ['DMVS_GAD'],
                          state__in: [
                            'WAITING_FOR_REJECT',
                            'WAITING_FOR_REJECT_FAILED',
                            'WAITING_FOR_IMPORT',
                            'IMPORT_INTERRUPTED',
                            'CLOSE_INTERRUPTED',
                            'IMPORTING',
                            'WAITING_FOR_CLOSE',
                            'CLOSING',
                          ],
                        }}
                      />
                    </li>
                    <li>
                      <FilterLink
                        id='managerDocListDmvsGadClosed'
                        to='managerDocList'
                        label={formatMessage(msg.dmvsGadClosed)}
                        filter={{
                          prejimka_type__in: ['DMVS_GAD'],
                          flow__in: ['DMVS_GAD'],
                          state__in: ['CLOSED'],
                        }}
                      />
                    </li>
                    <li>
                      <FilterLink
                        id='managerDocListDmvsGadEditing'
                        to='managerDocList'
                        label={formatMessage(msg.dmvsGadEditing)}
                        filter={{
                          prejimka_type__in: ['DMVS_GAD'],
                          flow__in: ['DMVS_GAD'],
                          state__in: ['EDITING', 'IMPORTED'],
                        }}
                      />
                    </li>
                    <li>
                      <FilterLink
                        id='managerDocListDmvsGadTakenOver'
                        to='managerDocList'
                        label={formatMessage(msg.dmvsGadTakenOver)}
                        filter={{
                          prejimka_type__in: ['DMVS_GAD'],
                          flow__in: ['DMVS_GAD'],
                          state__in: ['TAKEN_OVER'],
                        }}
                      />
                    </li>
                    <li>
                      <FilterLink
                        id='managerDocListDmvsGadRejected'
                        to='managerDocList'
                        label={formatMessage(msg.dmvsGadRejected)}
                        filter={{
                          prejimka_type__in: ['DMVS_GAD'],
                          flow__in: ['DMVS_GAD'],
                          state__in: ['REJECTED'],
                        }}
                      />
                    </li>
                    <li>
                      <FilterLink
                        id='managerDocListDmvsGadFailed'
                        to='managerDocList'
                        label={formatMessage(msg.dmvsGadFailed)}
                        filter={{
                          prejimka_type__in: ['DMVS_GAD'],
                          flow__in: ['DMVS_GAD'],
                          state__in: [
                            'CLOSE_FAILED',
                            'IMPORTED_WITH_ERRORS',
                            'IMPORT_FAILED',
                            'NOTIFYING_CLOSE_FAILED',
                            'WAITING_FOR_REJECT_FAILED',
                            'SIGNED_FAILED',
                          ],
                        }}
                      />
                    </li>
                  </ul>
                </li>
              </Collapsible>
            )}
            {/* DMVS CROSS - PRESHRANICNI EDITACE */}
            {auth.hasPermission('RelatedApps', 'allow_manager_all', null) && (
              <Collapsible
                isClosed={!!collapsible.managerDocListDmvsCross}
                data={'managerDocListDmvsCross'}
                onClick={onCollapseClick}
                headElement={
                  <FilterLink
                    id='managerDocListDmvsCross'
                    to='managerDocList'
                    label={formatMessage(msg.dmvsCross)}
                    filter={{
                      flow__in: FLOW_CROSS,
                    }}
                  />
                }
              >
                <li>
                  <ul className='sg-a-mt-1 sg-u-vs-1 dmx-menu-group'>
                    <li>
                      <FilterLink
                        id='managerDocListDmvsCrossNew'
                        to='managerDocList'
                        label={formatMessage(msg.dmvsCrossNew)}
                        filter={{
                          flow__in: FLOW_CROSS,
                          state__in: ['SUBMITTED', 'READY_TO_CHECK_SVU_CROSS_KRAJ'],
                        }}
                      />
                    </li>
                    <li>
                      <FilterLink
                        id='managerDocListDmvsCrossProcessing'
                        to='managerDocList'
                        label={formatMessage(msg.dmvsCrossProcessing)}
                        filter={{
                          flow__in: FLOW_CROSS,
                          state__in: [
                            'CLOSING',
                            'DELEGATE_REJECTED',
                            'EDITING',
                            'IMPORTED',
                            'IMPORTING',
                            'NOTIFYING_CLOSE',
                            'PROCESSED',
                            'PROCESSING',
                            'READY_TO_IMPORT',
                            'READY_TO_PROCESS',
                            'READY_TO_SYNCHRONIZE',
                            'REJECTED_BY_COUNTERPART',
                            'SYNCHRONIZED',
                            'SYNCHRONIZING',
                            'WAITING_FOR_CLOSE',
                            'WAITING_FOR_IMPORT',
                            'WAITING_FOR_REJECT',
                            'WAITING_FOR_PROCESS',
                            'WAITING_FOR_SYNCHRONIZE',
                            'EDIT_TAKEOVER_REJECTED',
                          ],
                        }}
                      />
                    </li>
                    <li>
                      <FilterLink
                        id='managerDocListDmvsCrossWaiting'
                        to='managerDocList'
                        label={formatMessage(msg.dmvsCrossWaiting)}
                        filter={{
                          flow__in: FLOW_CROSS,
                          state__in: [
                            'DELEGATED',
                            'PROCESSED_SENT_TO_COUNTERPART',
                            'SENT_TO_COUNTERPART',
                            'WAITING_FOR_SYNCHRONIZE_DATA',
                            'EDIT_REJECTED',
                          ],
                        }}
                      />
                    </li>
                    <li>
                      <FilterLink
                        id='managerDocListDmvsCrossClosed'
                        to='managerDocList'
                        label={formatMessage(msg.dmvsCrossClosed)}
                        filter={{
                          flow__in: FLOW_CROSS,
                          state__in: ['CLOSED'],
                        }}
                      />
                    </li>
                    <li>
                      <FilterLink
                        id='managerDocListDmvsCrossRejected'
                        to='managerDocList'
                        label={formatMessage(msg.dmvsCrossRejected)}
                        filter={{
                          flow__in: FLOW_CROSS,
                          state__in: ['REJECTED'],
                        }}
                      />
                    </li>
                    <li>
                      <FilterLink
                        id='managerDocListDmvsCrossFailed'
                        to='managerDocList'
                        label={formatMessage(msg.dmvsCrossFailed)}
                        filter={{
                          flow__in: FLOW_CROSS,
                          state__in: [
                            'CLOSE_FAILED',
                            'DELEGATE_FAILED',
                            'FAILED_TO_GET_SYNCHRONIZE_DATA',
                            'FAILED_TO_SEND_SYNCHRONIZE_DATA',
                            'IMPORT_FAILED',
                            'NOTIFYING_CLOSE_FAILED',
                            'DMVS_COMMUNICATION_FAILED',
                            'PROCESS_FAILED',
                            'IMPORTED_WITH_ERRORS',
                            'SEND_TO_COUNTERPART_FAILED',
                            'SYNCHRONIZE_FAILED',
                            'WAITING_FOR_REJECT_FAILED',
                          ],
                        }}
                      />
                    </li>
                    <li>
                      <FilterLink
                        id='managerDocListDmvsCrossSvu'
                        to='managerDocList'
                        label={formatMessage(msg.dmvsCrossSvu)}
                        filter={{
                          flow__in: ['SVU_OWNER', 'SVU_WORKER'],
                          has_svu_names: true,
                        }}
                      />
                    </li>
                  </ul>
                </li>
              </Collapsible>
            )}
            {/* DMVS DTI */}
            {auth.hasPermission('RelatedApps', 'allow_manager_all', null) && (
              <Collapsible
                isClosed={!!collapsible.managerDocListDmvsDti}
                data={'managerDocListDmvsDti'}
                onClick={onCollapseClick}
                headElement={
                  <FilterLink
                    id='managerDocListDmvsDti'
                    to='managerDocList'
                    label={formatMessage(msg.dmvsDti)}
                    filter={{
                      prejimka_type__in: ['DMVS_DTI'],
                      flow__in: ['DMVS_DTI'],
                    }}
                  />
                }
              >
                <li>
                  <ul className='sg-a-mt-1 sg-u-vs-1 dmx-menu-group'>
                    <li>
                      <FilterLink
                        id='managerDocListDmvsDtiOngoing'
                        to='managerDocList'
                        label={formatMessage(msg.dmvsDtiOngoing)}
                        filter={{
                          prejimka_type__in: ['DMVS_DTI'],
                          flow__in: ['DMVS_DTI'],
                          state__in: [
                            'WAITING_FOR_IMPORT',
                            'CLOSE_INTERRUPTED',
                            'IMPORT_INTERRUPTED',
                            'IMPORTING',
                            'WAITING_FOR_CLOSE',
                            'CLOSING',
                          ],
                        }}
                      />
                    </li>
                    <li>
                      <FilterLink
                        id='managerDocListDmvsDtiClosed'
                        to='managerDocList'
                        label={formatMessage(msg.dmvsDtiClosed)}
                        filter={{
                          prejimka_type__in: ['DMVS_DTI'],
                          flow__in: ['DMVS_DTI'],
                          state__in: ['CLOSED'],
                        }}
                      />
                    </li>
                    <li>
                      <FilterLink
                        id='managerDocListDmvsDtiRejected'
                        to='managerDocList'
                        label={formatMessage(msg.dmvsDtiRejected)}
                        filter={{
                          prejimka_type__in: ['DMVS_DTI'],
                          flow__in: ['DMVS_DTI'],
                          state__in: ['REJECTED'],
                        }}
                      />
                    </li>
                    <li>
                      <FilterLink
                        id='managerDocListDmvsDtiFailed'
                        to='managerDocList'
                        label={formatMessage(msg.dmvsDtiFailed)}
                        filter={{
                          prejimka_type__in: ['DMVS_DTI'],
                          flow__in: ['DMVS_DTI'],
                          state__in: [
                            'CLOSE_FAILED',
                            'CLOSE_CHECKS_FAILED',
                            'NOTIFYING_CLOSE_FAILED',
                            'IMPORT_FAILED',
                          ],
                        }}
                      />
                    </li>
                  </ul>
                </li>
              </Collapsible>
            )}
            {/* DTMK DTI */}
            {(auth.hasPermission('RelatedApps', 'allow_manager_all', null) ||
              auth.hasPermission('RelatedApps', 'allow_manager_dtm_dti', null)) && (
                <li>
                  <div className='sg-a-ml-0'>
                    <FilterLink
                      id='managerDocListIsDtm'
                      to='managerDocList'
                      label={formatMessage(msg.dtmkDti)}
                      filter={{
                        prejimka_type__in: ['DTM'],
                        flow__in: ['DTM'],
                      }}
                    />
                  </div>
                </li>
              )}
            {/* DTMK KAD */}
            {manager?.modules?.podaniKad &&
              auth.hasPermission('RelatedApps', 'allow_manager_all', null) && (
                <li>
                  <div className='sg-a-ml-0'>
                    <FilterLink
                      id='managerDocListPodaniKad'
                      to='managerDocList'
                      label={formatMessage(msg.podaniKadList)}
                      filter={{
                        prejimka_type__in: ['DTM_KAD'],
                        flow__in: ['DTM_KAD'],
                      }}
                    />
                  </div>
                </li>
              )}
          </ul>
        </li>
        {/* EPSI */}
        {/* {auth.hasPermission('RelatedApps', 'allow_manager_epsi', null) && ( */}
        {manager?.modules?.epsi && (
          <li>
            <p className='sg-u-type-sideNavHeading-inverse'>
              <FormattedMessage {...msg.epsiSection} />
            </p>
            <ul className='sg-a-mt-1 sg-u-vs-1'>
              <li>
                <FilterLink id='managerEpsi' to='managerEpsi' label={formatMessage(msg.epsi)} />
              </li>
            </ul>
          </li>
        )}
        {/* )} */}
        {/* SUBJEKTY */}
        {manager?.modules?.subjects && auth.hasPermission('Subjects', 'list.view', null) && (
          <li>
            <p className='sg-u-type-sideNavHeading-inverse'>
              <FormattedMessage {...msg.subjects} />
            </p>
            <ul className='sg-a-mt-1 sg-u-vs-1'>
              <li>
                <FilterLink id='managerSubjectList' to='managerSubjectList' />
              </li>
            </ul>
          </li>
        )}
        {/* GEODESISTS */}
        {manager?.modules?.geodesists && auth.hasPermission('Geodesists', 'list.view', null) && (
          <li>
            <p className='sg-u-type-sideNavHeading-inverse'>
              <FormattedMessage {...msg.geodesists} />
            </p>
            <ul className='sg-a-mt-1 sg-u-vs-1'>
              <li>
                <FilterLink id='managerGeodesistList' to='managerGeodesistList' />
              </li>
            </ul>
          </li>
        )}
        {/* SVU R7 oblasti */}
        {manager?.modules?.svu && auth.hasPermission('R7aUrceniEditoraZps', 'list.view', null) && (
          <li>
            <p className='sg-u-type-sideNavHeading-inverse'>
              <FormattedMessage {...msg.svu} />
            </p>
            <ul className='sg-a-mt-1 sg-u-vs-1'>
              {auth.hasPermission('R7aUrceniEditoraZps', 'create.view', null) && (
                <li>
                  <FilterLink id='managerNewSvu' to='managerNewSvu' />
                </li>
              )}
              <li>
                <FilterLink id='managerSvuList' to='managerSvuList' />
              </li>
            </ul>
          </li>
        )}
      </ul>
    </>
  );
};

export const ManagerMenu: React.FC = () => {
  const formatMessage = useMessage();
  const { homeLink, customerType } = useSelector((state) => state.app.config);
  const config = useSelector((state) => state.app.config.manager);

  const MenuBody = useMemo(() => {
    if (['dtm', 'gp', 'ipr'].includes(customerType)) return DtmMenu;
    return CustomMenu;
  }, [customerType]);

  return (
    <Menu
      title={formatMessage(msg.title)}
      subtitle={formatMessage(msg.subtitle)}
      appLink='managerHome'
      homeLink={homeLink}
      userDocumentation={config?.userDocumentation}
    >
      <MenuBody />
    </Menu>
  );
};
